import {useEffect, useState} from "react";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";

type Province = {
  cod_province: string,
  des_province: string,
}

export const useHomeProvinces = () => {

  // hooks
  const countryApiRequest = useCountryAxiosInstance();

  // state
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Province[]>();

  // handlers
  const fetch = async () => {
    setLoading(true);
    try {
      return await countryApiRequest!.get("/worksites/home/provinces") as unknown as Province[];
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetch().then(setData);
  }, []);

  return {loading, data};
}